var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( indicator_type == 'g' ) { 
__p+=' <div id="bar--container"></div> ';
 } else { 
__p+=' ';
 if ( !display_i ) { 
__p+=' <div class="col-6 container--left"> <div class="company-type"> <i class="fa fa-circle"></i> Internet and Mobile Ecosystem Companies </div> <div id="bar--container--internet"></div> </div> ';
 } 
__p+=' ';
 if ( !display_t ) { 
__p+=' <div class="col-6 container--right"> <div class="company-type"> <i class="fa fa-circle"></i> Telecommunications companies </div> <div id="bar--container--telco"></div> </div> ';
 } 
__p+=' ';
 }
__p+='';
}
return __p;
};
